<template>
  <nav class="flex items-center justify-between flex-wrap w-full text-sm">
    <div class="flex items-center">
      <a href="/" :title="siteName" class="inline-flex items-center">
        <img class="h-4 md:h-6 mr-3" src="/assets/img/logo.svg" :alt="siteName" />
      </a>
    </div>
    <div class="block md:hidden">
      <svg
        @click="expand"
        v-show="!expanded"
        id="js-nav-menu-show"
        xmlns="http://www.w3.org/2000/svg"
        class="md:hidden fill-current text-black h-4 w-4"
        viewBox="0 0 32 32"
      >
        <path
          d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z"
        />
      </svg>

      <svg
        @click="close"
        v-show="expanded"
        id="js-nav-menu-hide"
        xmlns="http://www.w3.org/2000/svg"
        class="md:hidden fill-current text-black h-4 w-4"
        viewBox="0 0 36 30"
      >
        <polygon
          points="32.8,4.4 28.6,0.2 18,10.8 7.4,0.2 3.2,4.4 13.8,15 3.2,25.6 7.4,29.8 18,19.2 28.6,29.8 32.8,25.6 22.2,15 "
        />
      </svg>
    </div>
    <div :class="expanded ? 'block' : 'hidden'" class="w-full md:flex md:items-center md:w-auto">
      <div class="flex flex-col md:flex-row text-sm md:flex-grow mt-2 md:mt-0">
        <a
          v-for="item in siteMenu"
          :key="item.title"
          :href="item.link"
          class="py-2 md:py-0 md:ml-6 hover:text-blue hover:no-underline"
          :class="isActive(item.link) ? 'text-blue font-medium' : 'font-normal text-grey-darker'"
        >{{ item.title }}</a>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  props: ["site-menu", "site-name"],
  data() {
    return {
      expanded: false
    };
  },
  methods: {
    expand() {
      this.expanded = true;
    },
    close() {
      this.expanded = false;
    },
    isActive(path) {
      if (window.location.pathname.endsWith("/") && path.length > 1) {
        return path === window.location.pathname.slice(0, -1);
      }

      return path === window.location.pathname;
    }
  }
};
</script>
